import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.splice.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Dialog from "@/view/pages/partials/Dialog.vue";
import { PATCH } from "@/core/services/store/request.module";
export default {
  props: {
    dialog: {
      type: Boolean,
      required: true,
      default: false
    },
    product: {
      type: Boolean,
      default: false
    },
    service: {
      type: Boolean,
      default: false
    },
    category: {
      type: Array,
      default: function _default() {
        return new Array();
      }
    }
  },
  watch: {
    category: {
      deep: true,
      immediate: true,
      handler: function handler(param) {
        this.categoryList = param;
      }
    }
  },
  data: function data() {
    return {
      pageLoading: false,
      categoryList: [{
        text: null
      }]
    };
  },
  methods: {
    updateProductCategory: function updateProductCategory() {
      var _this = this;

      _this.pageLoading = true;

      _this.$store.dispatch(PATCH, {
        url: "setting/product-category",
        data: {
          product_category: _this.categoryList
        }
      }).then(function () {
        _this.$emit("close-dialog", true);

        _this.$emit("get-product-category", true);
      }).catch(function (error) {
        _this.logError(error);
      }).finally(function () {
        _this.pageLoading = false;
      });
    },
    createProductCategory: function createProductCategory() {
      this.categoryList.push({
        text: null
      });
    },
    deleteProductCategory: function deleteProductCategory(index) {
      if (this.categoryList.length > 1) {
        this.categoryList.splice(index, 1);
      }
    },
    get_title: function get_title() {
      if (this.product) {
        return "Product";
      }

      if (this.service) {
        return "Service";
      }
    }
  },
  components: {
    Dialog: Dialog
  },
  computed: {
    dialogWidth: function dialogWidth() {
      return this.lodash.toSafeInteger(document.body.clientWidth / 100 * 50);
    }
  }
};